import React, { useState } from 'react';
import { useContent } from '../context/ContentContext';
import { PageBanner } from './About';
import { X } from 'lucide-react';
import { resolveImageUrl } from '../components/ImageUpload';

export default function Gallery() {
  const { gallery, site_content } = useContent();
  const galleryImages = (gallery || []).map(g => g.image || g);
  const [lightbox, setLightbox] = useState(null);

  return (
    <div>
      <PageBanner title={site_content?.page_gallery_title || 'Our Gallery'} />
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
            {galleryImages.map((g, i) => (
              <button key={g} onClick={() => setLightbox(g)} className="gallery-item rounded block">
                <img src={resolveImageUrl(g)} alt={`Gallery ${i+1}`} loading="lazy" />
              </button>
            ))}
          </div>
        </div>
      </section>
      {lightbox && (
        <div onClick={() => setLightbox(null)} className="fixed inset-0 bg-black/80 z-[70] flex items-center justify-center p-4 animate-in fade-in">
          <button className="absolute top-4 right-4 text-white w-10 h-10 bg-white/10 hover:bg-[#f7941e] rounded-full flex items-center justify-center transition-colors" aria-label="close"><X className="w-5 h-5" /></button>
          <img src={resolveImageUrl(lightbox)} alt="preview" className="max-h-[85vh] max-w-[90vw] object-contain rounded shadow-2xl" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}
